(function () {
  'use strict';

  var STORAGE_KEY = 'ap-cd-target';

  function pad(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  function getGlobalConfig() {
    var el = document.getElementById('ap-countdown-config');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function getNextDaily(resetTime) {
    var parts = resetTime.split(':');
    var h = parseInt(parts[0], 10) || 0;
    var m = parseInt(parts[1], 10) || 0;
    var now = new Date();
    var target = new Date(now);
    target.setHours(h, m, 0, 0);
    if (target <= now) target.setDate(target.getDate() + 1);
    return target;
  }

  function getStoredTarget() {
    try {
      var stored = localStorage.getItem(STORAGE_KEY);
      if (!stored) return null;
      var ts = parseInt(stored, 10);
      if (isNaN(ts)) return null;
      var d = new Date(ts);
      return d > new Date() ? d : null;
    } catch (e) { return null; }
  }

  function storeTarget(date) {
    try { localStorage.setItem(STORAGE_KEY, String(date.getTime())); } catch (e) {}
  }

  function destroyCountdown(el) {
    if (el._apCdInterval) {
      clearInterval(el._apCdInterval);
      el._apCdInterval = null;
    }
    el._apCdInit = false;
  }

  function initCountdown(el) {
    destroyCountdown(el);
    el._apCdInit = true;

    var cfg = getGlobalConfig();
    if (!cfg && !el.getAttribute('data-mode')) {
      el.hidden = true;
      return;
    }

    var mode = el.getAttribute('data-mode') || (cfg && cfg.mode) || 'daily';
    var daily = el.getAttribute('data-daily') || (cfg && cfg.daily) || '00:00';
    var expiry = el.getAttribute('data-expiry') || (cfg && cfg.expiry) || '';
    var hideExpired = el.getAttribute('data-hide-expired') === 'true' || (cfg && cfg.hideExpired);

    var labelEl = el.querySelector('.ap-cd-label');
    var expiredEl = el.querySelector('[data-ap-cd-expired]');
    if (cfg) {
      if (labelEl && !labelEl.textContent.trim() && cfg.text) labelEl.textContent = cfg.text;
      if (expiredEl && !expiredEl.textContent.trim() && cfg.expiredText) expiredEl.textContent = cfg.expiredText;
    }

    var digits = el.querySelector('[data-ap-cd-digits]');
    var hEl = el.querySelector('[data-ap-cd-h]');
    var mEl = el.querySelector('[data-ap-cd-m]');
    var sEl = el.querySelector('[data-ap-cd-s]');
    var target;

    var stored = getStoredTarget();
    if (stored) {
      target = stored;
    } else if (mode === 'fixed' && expiry) {
      target = new Date(expiry);
    } else {
      target = getNextDaily(daily);
    }
    storeTarget(target);

    function tick() {
      var now = new Date();
      var diff = target - now;

      if (diff <= 0) {
        if (mode === 'daily') {
          target = getNextDaily(daily);
          storeTarget(target);
          diff = target - now;
        } else {
          if (hideExpired) {
            el.hidden = true;
          } else if (expiredEl && expiredEl.textContent.trim()) {
            digits.hidden = true;
            if (labelEl) labelEl.hidden = true;
            expiredEl.hidden = false;
          } else {
            el.hidden = true;
          }
          clearInterval(el._apCdInterval);
          el._apCdInterval = null;
          try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
          return;
        }
      }

      var totalSec = Math.floor(diff / 1000);
      var h = Math.floor(totalSec / 3600);
      var m = Math.floor((totalSec % 3600) / 60);
      var s = totalSec % 60;
      hEl.textContent = pad(h);
      mEl.textContent = pad(m);
      sEl.textContent = pad(s);
    }

    tick();
    el._apCdInterval = setInterval(tick, 1000);
  }

  function boot() {
    document.querySelectorAll('[data-ap-countdown]').forEach(initCountdown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('ap:countdown:reinit', function () {
    document.querySelectorAll('[data-ap-countdown]').forEach(initCountdown);
  });

  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('[data-ap-countdown]').forEach(initCountdown);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-ap-countdown]').forEach(destroyCountdown);
  });
})();
